<template>
  <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
    <Component
      :is="confirmHref ? 'a' :'button'"
      type="button"
      :id="proceedButtonId"
      :href="confirmHref"
      class="inline-flex w-full items-center justify-center rounded-md px-4 py-2 text-base font-medium text-white shadow-sm group sm:ml-3 sm:w-auto sm:text-sm focus:outline-none ring-offset-2 focus:ring"
      :class="proceedButtonClasses"
      :disabled="loading"
      @click="handleClose( true, false)">
      {{ proceedButtonText }}
      <span v-if="loading" class="ml-2 spinning-loader"
            style="--loader-diameter:17px;--loader-border-size:3px;"/>
      <Component
        v-else-if="proceedButtonIcon"
        :is="proceedButtonIcon"
        class="h-3 w-3 group-active:translate-x-2 transition-all ml-1.5 group-hover:translate-x-1"
      />
    </Component>
    <button
      v-if="!hideCancelButton"
      ref="cancelButtonRef"
      type="button"
      class="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 ring-bdBlue-600 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
      @click="handleClose( false)">
      {{ cancelButtonText }}
    </button>
  </div>
</template>

<script setup>
const props = defineProps({
  proceedButtonClasses: String,
  proceedButtonText: String,
  proceedButtonIcon: [Object, Function],
  hideCancelButton: Boolean,
  cancelButtonText: String,
  confirmHref: String,
  showButtons: Boolean,
  loading: Boolean,
  proceedButtonId: String,
  closeOnCancel: {
    type: Boolean,
    default: true,
  },
});

const emits = defineEmits(["confirm", "cancel", "update:open"]);

const handleClose = (proceedWithAction = false, wasClickOutside) => {
  if (props.confirmHref && proceedWithAction) return;
  if (proceedWithAction) emits("confirm");
  else {
    emits("cancel", wasClickOutside);
    if (props.closeOnCancel) emits("update:open", false);
  }
};
</script>
